<template>
    <div>
        <div class="container-fluid">
            <div class="llp-container-section heightcontainer ">
                <top-header id="height2"></top-header>
                <main-menu id="height3"></main-menu>
                <div class="modal-backdrop">
                    <div class="card col-lg-10 col-md-8 mt-md-4 col-11 p-0">
                        <div class="postmodalcontent">
                            <div class="modal-header borderbottom p-4">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <nav class="navbar navbar-expand-lg bg-info text-white">
                                    <span>
                                        <b>Sales & Property Tax {{ currentPage }}</b>
                                    </span>
                                </nav>
                                <div class="row p-2 justify-content-center">
                                    <div class="col">
                                        <div class="table-responsive table-responsive-sm mb-5"
                                            style="overflow:auto; max-height: 350px;">
                                            <v-table id="myappsTableView" :data="propertyTaxList"
                                                class="table table-sm table-bordered table-striped">
                                                <thead class="table-month-header-blue wrap-text" slot="head">
                                                    <v-th sortKey="zipCode">Zip Code</v-th>
                                                    <v-th sortKey="state">State</v-th>
                                                    <v-th sortKey="country">County</v-th>
                                                    <v-th sortKey="city">City</v-th>
                                                    <v-th sortKey="stateSalesTax">State Sales Tax (%)</v-th>
                                                    <v-th sortKey="countrySalesTax">County Sales Tax (%)</v-th>
                                                    <v-th sortKey="citySalesTax">City Sales Tax (%)</v-th>
                                                    <v-th sortKey="localReg">Local/Regional Sales Tax (%)</v-th>
                                                    <v-th sortKey="personalPropertyTax">Personal Property Tax (%)</v-th>
                                                    <v-th sortKey="totalSalesTax">Total Sales Tax (%)</v-th>
                                                    <v-th sortKey="effectiveDate">Effective Date</v-th>
                                                    <v-th sortKey="stateStatus">State Status</v-th>
                                                    <v-th sortKey="permitted">Permitted</v-th>
                                                </thead>
                                                <tbody slot="body" slot-scope="{ displayData }">
                                                    <tr v-for="property in displayData">

                                                        <td class="table-month-td">{{ property.zipCode }}</td>
                                                        <td class="table-month-td">{{ property.state }}</td>
                                                        <td class="table-month-td">{{ property.country }}</td>
                                                        <td class="table-month-td">{{ property.city }}</td>
                                                        <td class="table-month-td">{{ property.stateSalesTax }}</td>
                                                        <td class="table-month-td">{{ property.countrySalesTax }}</td>
                                                        <td class="table-month-td">{{ property.citySalesTax }}</td>
                                                        <td class="table-month-td">{{ property.localReg }}</td>
                                                        <td class="table-month-td">{{ property.personalPropertyTax }}</td>
                                                        <td class="table-month-td">{{ property.totalSalesTax }}</td>
                                                        <td class="table-month-td">{{
                                                            property.effectiveDate | moment("MM/DD/YYYY")
                                                        }}
                                                        </td>
                                                        <td class="table-month-td text-title">{{ property.stateStatus }}
                                                        </td>
                                                        <td class="table-month-td">{{ property.permitted }}</td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                            <template v-if="propertyTaxList.length == 0">
                                                <center>
                                                    <span>
                                                        <b>No records found</b>
                                                        <br />
                                                    </span>
                                                </center>
                                            </template>

                                            <b-pagination v-if="totalRows > 0" v-model="currentPage" :total-rows="totalRows"
                                                :per-page="perPage" aria-controls="myappsTableView"
                                                @change="handleClick($event)"></b-pagination>

                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpcommon from '../../../js/http-common.js';

export default {
    components: {
        MainMenu,
        TopHeader,
        BottomFooter
    },
    name: "viewSalesTable",
    props: ['viewTableSearchData', 'perPage', 'isSearch'],
    data() {
        return {
            currentPage: 1,
            propertyTaxList: [],
            totalRows: 0
        }

    },
    mounted() {
        this.myFunction();
        this.menuheight();
        if (!this.isSearch) {
            this.fetchdata();
        } else {
            this.propertyTaxList = this.viewTableSearchData;
            this.totalRows = this.viewTableSearchData.length;
        }
    },
    methods: {
        myFunction() {
            var elmnt = document.getElementById('height2')
            var elmnt1 = document.getElementById('height3')
            var txt = elmnt.offsetHeight
            var width = elmnt.offsetWidth
            var txt1 = elmnt1.offsetHeight
            var ht = txt + txt1
            $('#reporting').css('margin-top', txt + txt1 + 3)
        },
        menuheight() {
            var elmnt = document.getElementById('height2')
            var txt = elmnt.offsetHeight
            $('#height3').css('margin-top', txt)
        },
        close() {
            this.$emit('closeViewTableModal')
        },
        handleClick(event) {
            this.currentPage = event;

            if (!this.isSearch) {
                this.fetchdata();
            }
        },

        fetchdata: function () {
            let url = `/salesPropertyTax/getAllSalesTax?page=${this.currentPage}&size=${this.perPage}`;
            httpcommon
                .get(url)
                .then(response => {
                    if (response.status == 200) {
                        this.propertyTaxList = response.data.content;
                        this.totalRows = response.data.totalCount;
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
        },
    },
}
</script>

<style scoped>
.bottom {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
}

.modal-backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000 !important;
}

.pageloader {
    width: 7%;
    margin-top: 5%;
    margin-bottom: 5%;
    margin-left: 46%;
}

#introVideo {
    width: 100%;
    background: black;
}

.card {
    padding: -5px !important;
    margin: 0 auto;
}

label input[type="radio"]:checked~span {
    color: #007AFF;
}

.postmodalcontent {
    border: none !important;
}

.btn:focus {
    box-shadow: none;
}

.tagLineReport {
    height: 10px;
    color: #1F1F1F;
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 0;
    font-style: italic;
    opacity: 60%
}

.button-cancel11 {
    border: 1px solid #1f1f1f;
    border-radius: 4px;
    transition: ease-out 0.3s;
    font-size: 14px !important;
    position: relative;
    z-index: 1;
}

.modal-header {
    border: none;
}

.bodymodal11 {
    padding: 0 !important;
    height: 80vh;
    overflow-y: auto;

}

.bodymodal11 {
    background-color: white;
}

.profile-border {
    padding: 2px;
    border: 2px solid #ced4da;
    border-radius: 50%;
}

/*hide scroll bar */
/*.bodymodal11::-webkit-scrollbar {
  display: none;
}*/
/* Hide scrollbar for IE, Edge and Firefox */

/*.bodymodal11 {
  -ms-overflow-style: none;
  scrollbar-width: none;
}*/
.close {
    padding: 1px 7px 5px 7px !important;
    margin-top: -3px !important;
    margin-right: 5px !important;
}

.close:hover {
    background-color: rgba(161, 166, 179, 0.1);
    border-radius: 60%;
    border: 1px solid rgba(161, 166, 179, .5);
}

.loadingBgImg {
    background: transparent url('../../../assets/logout.png') center no-repeat;
    background-size: 30px 30px;
}

@media screen and (max-width : 600px) {
    .card {
        margin-top: 4%;
    }
}

.nav-link {
    display: block;
    padding: 0.5rem 1rem;
    background-color: #17a2b8;
    color: black;
    margin-left: 5px;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
    color: black;
    background-color: white;
    border-color: #A9A9A9;
    border-bottom: none;
}

.sidebyside {
    float: right;
}

.text-title {
    text-transform: capitalize;
}
</style>